/* eslint-disable react/prop-types */
/* eslint-disable import/no-unresolved */
import React, { useContext } from 'react';
import {
    Button,
    ModalNext,
    ModalBody,
    ModalFooter,
} from '@jutro/components';
import './view-popup-message.scss';
import { TranslatorContext } from '@jutro/locale';
import messages from './view-popup-message.messages';

export default function DisplayPopup({
    isOpen,
    onResolve,
    closeButtonText,
    title,
    children,
    name,
    onClose,
    customClassName
    // array object for dialog content
}) {
    const translator = useContext(TranslatorContext);
    function handleClose() {
        onResolve(true); // return value for dialog close is not used.

        if (typeof onClose === 'function') {
            onClose();
        }
    }
    return (
        <ModalNext
            isOpen={isOpen}
            className={`modal-next ${customClassName || ''}`}
            onRequestClose={handleClose}
            contentLabel={name}
        >
            <h2 className="title-text">{title}</h2>
            <p className="modal-body">{children}</p>
            {closeButtonText && (
                <ModalFooter className="modal-footer">
                    <div className="closeButton">
                        <Button fullWidth type="tertiary" onClick={handleClose} aria-label={translator(messages.closeButtonAriaLabel)}>
                            {closeButtonText}
                        </Button>
                    </div>
                </ModalFooter>
            )}
        </ModalNext>
    );
}
